/* eslint-disable react-hooks/exhaustive-deps */
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import SiharaisakiService from "../../../service/master/siharaisaki/siharaisakiService"
import {
  TSiharaisakiInfoGetRes,
  TSiharaisakiListGetReq,
} from "../../../service/master/siharaisaki/TSiharaisaki"

import { 区分分類コード } from "../../../constant/enum/codes"
import {
  マスタ管理メニューコード,
  メニューコード,
} from "../../../constant/menuCode"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import KubunService from "../../../service/master/kubun/kubunService"
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import { RootState } from "../../../globalStore/rootreducer"

/**
 * 支払先マスタ一覧
 * @returns
 */
const MasterSiharaisakiList = () => {
  const history = useHistory()
  const location = useLocation()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.支払先マスタ
      )?.読み取り専用フラグ
  )

  //TODO:ページ名称確定必須
  let gridId = "MasterSiharaisakiList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TSiharaisakiInfoGetRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        住所: (i: TSiharaisakiInfoGetRes) => {
          return `${i.住所１ ?? ""}${i.住所２ ?? ""}${i.住所３ ?? ""}`
        },
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSiharaisakiListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TSiharaisakiListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new SiharaisakiService().getList(currentSearchCondition)

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TSiharaisakiListGetReq = queryString.parse(location.search)
    set支払先区分コード(query.支払先区分コード)
    set支払先コード(query.支払先コード)
    set支払先名(query.支払先名)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSiharaisakiListGetReq => {
    return {
      支払先区分コード: 支払先区分コード ?? undefined,
      支払先コード,
      支払先名,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TSiharaisakiListGetReq
  ) => {
    return {
      支払先区分コード: wjCore.isNullOrWhiteSpace(
        searchCondition.支払先区分コード ?? ""
      )
        ? ""
        : searchCondition.支払先区分コード,
      支払先CD: wjCore.isNullOrWhiteSpace(searchCondition.支払先コード ?? "")
        ? ""
        : searchCondition.支払先コード,
      支払先名: wjCore.isNullOrWhiteSpace(searchCondition.支払先名 ?? "")
        ? ""
        : searchCondition.支払先名,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set支払先区分コード("")
    set支払先コード("")
    set支払先名("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [支払先区分コード, set支払先区分コード] = useState<string | null>()
  const [支払先コード, set支払先コード] = useState<string>()
  const [支払先名, set支払先名] = useState<string>()

  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  //#region [comboboxState]
  // 支払先区分
  const [支払先区分ComboBox, set支払先区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [支払先区分IsLoadEnded, set支払先区分IsLoadEnded] =
    useState<boolean>(false)

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `支払先マスタ一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">支払先マスタ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-90rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-12rem">
                              <ComboBox.Kubun
                                placeholder="支払先区分"
                                分類コード={区分分類コード.マスタ.支払先区分}
                                isLoadEnded={支払先区分IsLoadEnded}
                                setIsLoadEnded={set支払先区分IsLoadEnded}
                                isAllSelect={true}
                                itemsSource={区分ItemSource}
                                selectedValue={支払先区分コード}
                                setSelectedValue={set支払先区分コード}
                                ComboBox={支払先区分ComboBox}
                                setComboBox={
                                  set支払先区分ComboBox
                                }></ComboBox.Kubun>
                            </div>
                            <div className="input-group">
                              <TextInput
                                style={{ width: "7rem" }}
                                id="支払先コード"
                                name="支払先コード"
                                value={支払先コード}
                                setValue={set支払先コード}
                                maxLength={4}
                                placeholder="支払先CD"
                              />
                              <TextInput
                                style={{ width: "25rem" }}
                                id="支払先名"
                                name="支払先名"
                                value={支払先名}
                                setValue={set支払先名}
                                maxLength={100}
                                placeholder="支払先名"
                              />
                            </div>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                headerComponent={
                  <>
                    {!読取専用フラグ && (
                      <Link
                        to={
                          util.getMenuPath(
                            マスタ管理メニューコード.支払先マスタ登録
                          )[0]
                        }
                        onClick={() =>
                          gridPageHelper.savePageConditionData(
                            location.pathname
                          )
                        }>
                        <Button disabled={isSearching}>
                          <FontAwesomeIcon icon={faPlusSquare} />
                          新規追加
                        </Button>
                      </Link>
                    )}
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  header=" "
                  allowMerging="true"
                  align="center"
                  width={80}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSiharaisakiInfoGetRes>
                    ) => {
                      // 支払先登録
                      const url = util.getMenuPath(
                        マスタ管理メニューコード.支払先マスタ登録
                      )[1]

                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )

                            //TODO: 受け渡すパラメータ確定後修正
                            history.push(
                              url.replaceAll(
                                ":id",
                                context.item.支払先ID.toString()
                              )
                            )
                          }}>
                          {!読取専用フラグ ? "編集" : "参照"}
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="支払先コード"
                  width={95}
                  header="支払先CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="支払先名"
                  width={300}
                  header="支払先名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="支払先区分名称1"
                  width={100}
                  header="支払先区分"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="住所"
                  width={450}
                  header="住所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="電話番号"
                  width={120}
                  header="電話番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="支払先担当者"
                  width={140}
                  header="支払先担当者"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="インボイス登録番号"
                  width={150}
                  header="登録番号"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default MasterSiharaisakiList
